import { useContext } from 'react';
import { InfrastructureChartsDataContext } from '../contexts/InfrastructureChartsDataContext';

export const useInfrastructureChartsDataContext = () => {
    return useContext(InfrastructureChartsDataContext);
};
